import { render } from "./BlogLayout.vue?vue&type=template&id=dd40d310"
import script from "./BlogLayout.vue?vue&type=script&lang=js"
export * from "./BlogLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__